export default {
  $id: "7",
  documentsList: [
    {
      $id: "8",
      id: "e8305821-2fc8-4358-9460-99f028e0d167",
      documentNumber: "68/01/2021/RZE",
    },
  ],
  selectedDocument: {
    $id: "9",
    id: "e8305821-2fc8-4358-9460-99f028e0d167",
    documentNumber: "68/01/2021/RZE",
  },
  cashboxList: [],
  selectedCashbox: null,
  FormOfPaymentsList: [
    {
      $id: "10",
      id: 1,
      disableCashbox: false,
      name: "Gotówka",
    },
    {
      $id: "11",
      id: 5,
      disableCashbox: true,
      name: "Przelew",
    },
    {
      $id: "12",
      id: 7,
      disableCashbox: true,
      name: "Przelew przedpłata",
    },
    {
      $id: "13",
      id: 8,
      disableCashbox: true,
      name: "Karta kredytowa",
    },
    {
      $id: "14",
      id: 9,
      disableCashbox: false,
      name: "Gotówka termin",
    },
    {
      $id: "15",
      id: 12,
      disableCashbox: true,
      name: "Kompensata",
    },
    {
      $id: "16",
      id: 13,
      disableCashbox: true,
      name: "Voucher",
    },
    {
      $id: "17",
      id: 14,
      disableCashbox: true,
      name: "POZOSTAŁE KOSZTY OPERACYJNE",
    },
    {
      $id: "18",
      id: 15,
      disableCashbox: true,
      name: "Karta system",
    },
    {
      $id: "19",
      id: 16,
      disableCashbox: true,
      name: "Karta terminal",
    },
    {
      $id: "20",
      id: 17,
      disableCashbox: true,
      name: "PayPal",
    },
  ],
  SelectedFormOfPayment: null,
  selectedFormOfPaymentRest: {
    $id: "21",
    id: 5,
    disableCashbox: true,
    name: "Przelew",
  },
  documentCurrency: "PLN",
  exchangeDate: "2021-01-15",
  description: null,
  exchangeRate: 1,
  documentCurrencyExchangeRate: 1,
  gross: 3900.99,
  grossInCurrency: 3900.99,
  grossInCurrencyLeftToPay: 0,
  grossLeftToPay: 0,
  paymentCurrency: "PLN",
  paymentAmount: 3900.99,
  paymentAmountInCurrency: 3900.99,
  paymentReferenceAmount: 3900.99,
  paymentSumAmount: 0,
  paymentSumAmountInCurrency: 0,
  addDate: "2021-01-18",
  paymentHasCashDocument: false,
  paymentFromBankStatement: false,
  isExchangeDifference: false,
  exchangeRateProvider: {
    $id: "22",
    currencyList: [],
    selectedCurrency: null,
    exchangeRate: 0,
    exchangeDate: "0001-01-01T00:00:00",
    currencyCode: null,
    dataIsLoading: false,
    currencyIsLoading: false,
    exhcangeDateIsLoading: false,
    exhcangeRateIsLoading: false,
  },
};
